<section>
    <div class="filters">
        <div class="filter">
            <input type="text" placeholder="Name">
        </div>
        <div class="filter">
            <label for="">title</label>
                <select name="" id="" Default=""> 
                    <option value="">دكتور</option>
                    <option value="">استاذ دكتور </option>
                    <option value="">استشارى</option>
                </select>
        </div>
        <div class="filter">
            <label for="">Specialization</label>
            <select name="" id="">
                <option value="">جراح قلب</option>
            </select>
        </div>

    </div>
</section>